export const MAX_ADD_SEATS = 100;

export const StartFreeTrail = 'Start 14 day free trial';

export const FileSyncAppLink =
  'https://wikifactory.com/platform/desktop-app-waitlist/';

export const RolesAndAccessControlLink =
  'https://wikifactory.com/platform/roles-and-permissions/';

export enum SubscriptionType {
  FREE = 'Free',
  PRO = 'PRO',
  BUSINESS = 'BUSINESS',
}

export const StorageUsageTotalMap = {
  [SubscriptionType.FREE]: '10GB',
  [SubscriptionType.PRO]: '100GB',
  [SubscriptionType.BUSINESS]: '1TB',
};
